import { deepComparison } from "client/Misc/compareUtils";
import {
	DependencyList,
	RefObject,
	useRef
} from "react";

type ValueEqualState<T> = {
	value: T;
	deps: DependencyList;
};

export function useValueEqualMemo<T>(
	factory: () => T,
	deps: DependencyList
): T {
	const ref: RefObject<ValueEqualState<T> | undefined> = useRef<ValueEqualState<T>>(undefined);

	if (!ref.current || !deepComparison(ref.current.deps, deps)) {
		ref.current = {
			value: factory(),
			deps
		};
	}

	return ref.current
		.value;
}
